import { CarouselContext, CarouselStoreInterface } from 'pure-react-carousel';
import { useContext, useEffect, useState } from 'react';

export default function useCurrentSlide(): number {
  const carouselContext: CarouselStoreInterface = useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = useState(carouselContext.state.currentSlide);
  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext.state.currentSlide);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  return currentSlide;
}
